module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "default-bg"
  }, [_c('normalBar', {
    attrs: {
      "title": "退款详情"
    }
  }), _vm._v(" "), (_vm.refundList && _vm.refundList.length) ? _c('div', [_c('div', {
    staticClass: "cancel-info-sec"
  }, _vm._l((_vm.refundList), function(item) {
    return _c('div', {
      staticClass: "info-item",
      class: {
        active: item.status == 1
      }
    }, [_c('span', {
      staticClass: "icon-circel"
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('div', [_c('p', [_vm._v(_vm._s(item.option))]), _vm._v(" "), _c('p', {
      staticClass: "text-grey"
    }, [_vm._v(_vm._s(item.createdTime))])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "refund-tips"
  }, [_vm._v("\n\t\t\t若退款迟迟未到账，请与客服联系：400-999-6666\n\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })]) : _c('div', {
    staticClass: "text-center"
  }, [_vm._v("暂无数据")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22b48911","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/orderRefundDetails.vue
// module id = 553
// module chunks = 1